import { CommonModule } from '@angular/common';
import { AuditDirectoryCellComponent } from '../../shared/audit/audit-directory-cell.component';
import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressBarModule } from 'primeng/progressbar';
import { SelectModule } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { forkJoin } from 'rxjs';
import { REFURBISHMENT_SOURCES, statusSeverity, warehousingBreadcrumb, warehousingHomeBreadcrumb } from '../warehousing-common';
import { WarehousingItem, WarehousingRefurbishment, WarehousingSearchFilters } from '../warehousing.model';
import { WarehousingPageHeaderComponent } from '../warehousing-page-header.component';
import { WarehousingSearchPanelComponent } from '../warehousing-search-panel.component';
import { WarehousingService } from '../warehousing.service';
import { itemIdentityLabel } from '../warehousing-item-display';

@Component({
  selector: 'app-warehousing-refurbishment',
  standalone: true,
  imports: [AuditDirectoryCellComponent,
    CommonModule, ReactiveFormsModule, RouterModule, BreadcrumbModule, ButtonModule, IftaLabelModule,
    InputGroupModule, InputGroupAddonModule, InputTextModule, ProgressBarModule, SelectModule, TableModule,
    TagModule, WarehousingPageHeaderComponent, WarehousingSearchPanelComponent
  ],
  templateUrl: './warehousing-refurbishment.component.html'
})
export class WarehousingRefurbishmentComponent implements OnInit {
  private fb = inject(FormBuilder);
  private warehousingService = inject(WarehousingService);
  isLoading = false;
  breadcrumbItems: MenuItem[] = warehousingBreadcrumb('Refurbishment');
  homeBreadcrumb: MenuItem = warehousingHomeBreadcrumb();
  refurbishments: WarehousingRefurbishment[] = [];
  items: WarehousingItem[] = [];
  refurbishmentSources = REFURBISHMENT_SOURCES;
  refurbishmentStatusOptions = [
    { label: 'In Progress', value: 'IN_PROGRESS' },
    { label: 'Completed', value: 'COMPLETED' },
    { label: 'Cancelled', value: 'CANCELLED' }
  ];

  searchForm = this.fb.group({
    keyword: [''],
    sourceType: [null as string | null],
    status: [null as string | null]
  });

  ngOnInit(): void { this.loadRefurbishments(); }

  loadRefurbishments(): void {
    this.isLoading = true;
    forkJoin({ refurbishments: this.warehousingService.getRefurbishments(this.searchFilters()), items: this.warehousingService.getItems() }).subscribe({
      next: response => {
        this.refurbishments = response.refurbishments.data || [];
        this.items = response.items.data || [];
        this.isLoading = false;
      },
      error: () => this.isLoading = false
    });
  }

  applySearch(): void {
    this.loadRefurbishments();
  }

  clearSearch(): void {
    this.searchForm.reset({
      keyword: '',
      sourceType: null,
      status: null
    });
    this.loadRefurbishments();
  }

  itemName(id?: number): string {
    const item = this.items.find(row => row.id === id);
    return itemIdentityLabel(item);
  }

  supplierName(refurbishment: WarehousingRefurbishment): string {
    return refurbishment.supplierClientName || refurbishment.vendorName || 'Internal team';
  }

  statusSeverity = statusSeverity;

  private searchFilters(): WarehousingSearchFilters {
    return this.searchForm.getRawValue();
  }
}
